var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-footer"},[_c('div',{staticClass:"app-footer__inner"},[_c('div',{staticClass:"app-footer-left"},[_c('FooterDots')],1),_c('div',{staticClass:"app-footer-right"},[_c('FooterMenu')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }